import route from '@motionelements/core/src/store/modules/route.js';

export default {
  namespaced: true,
  state: () => route.state,
  getters: route.getters,
  actions: route.actions,
  mutations: route.mutations,
};
